import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { SettingService } from 'src/app/core/service/setting.service';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  selector: 'app-dashboard-coordinator-top-right',
  templateUrl: './dashboard-coordinator-top-right.component.html',
  styleUrls: ['./dashboard-coordinator-top-right.component.scss']
})
export class DashboardCoordinatorTopRightComponent implements OnInit
{
  @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

  public topRightLoading = true;

  public totalEvents: number;

  public limitEventsHours = 0;
  public limitEventsText = {};

  public patientLabelString: string;

  constructor(
    private settingService: SettingService,
    private changeDetectorRef: ChangeDetectorRef,
    private translate: TranslateService
  ) { }

  public ngOnInit(): void
  {
    this.getEvents();
  }

  public showTooltip(e: ElementRef): void
  {
    this.tooltipDir.toggle(e, true);
  }
  
  public hideTooltip(): void
  {
    this.tooltipDir.hide();
  }

  public afterMemberCount(event: any): void
  {
    this.totalEvents = event;
    this.changeDetectorRef.detectChanges();
  }

  private getEvents()
  {
    this.settingService.getCachedSessionSettings().subscribe({
      next: (sessionSetting) =>
      {
        this.limitEventsHours = sessionSetting.noticeEventsHoursFilter !== undefined ?
          sessionSetting.noticeEventsHoursFilter : 24;

        // Get the translation used when file types is invalid
        this.translate.get(['CLINICAL-EVENTS-LIMIT']).subscribe({
          next: (res) =>
          {
            this.limitEventsText = res['CLINICAL-EVENTS-LIMIT'].replace('{{limitEvents}}', this.limitEventsHours);

            this.patientLabelString = sessionSetting.patientLabel;
            this.topRightLoading = false;
          }
        });
      }
    });
  }
}
